import React from 'react';
import { Navigate } from 'react-router-dom';
import UserManagement from '../components/admin/UserManagement';
import { useAuth } from '../utils/AuthContext';
import { canAccessPeopleTeam } from '../utils/employeeBenefitsAccess';
import '../components/pm/pm-shared.css';
import './OperationsHub.css';
import './PeopleHubPage.css';
import './PeopleTeamPage.css';

const PeopleTeamPage: React.FC = () => {
  const { user } = useAuth();
  if (!user || !canAccessPeopleTeam(user.role)) {
    return <Navigate to="/people" replace />;
  }

  return (
    <div className="people-hub-route-root people-team-page">
      <div className="ops-hub-toolbar">
        <div className="ops-hub-toolbar-left">
          <div>
            <h2 className="ops-hub-title">Team</h2>
            <p className="people-hub-subtitle">
              CRM accounts, pending invites, the 1099 pool, and crew still onboarding.
            </p>
          </div>
        </div>
      </div>
      <div className="people-team-body">
        <div className="people-hub-panel people-team-panel">
          <UserManagement />
        </div>
      </div>
    </div>
  );
};

export default PeopleTeamPage;
